import React, { useState } from "react";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import { Container, Subheader } from "@/Components";
import SettingsDetails from "@/Pages/Organization/Settings/SettingsDetails";
import SettingsBilling from "@/Pages/Organization/Settings/SettingsBilling";
import { SuccessMessage } from "@/Components/Messages";
import SettingsPlans from "@/Pages/Organization/Settings/SettingsPlans";
import { Tab, Tabs } from "@/Components/Tabs";
import LayoutIcon from "@/Components/LayoutIcon";
import { Cogwheel as CogwheelIcon } from "@/Icons";

export default function General({ organization, errors, flash, focus }) {
  return (
    <>
      {flash.status && <SuccessMessage>{flash.status}</SuccessMessage>}

      <Container
        padding=""
        className="md:dots-orange md:dots-orange--no-top-overflow relative z-10 before:top-[13rem]"
      >
        <Tabs items={["Company details", "Billing info"]}>
          {/* hidden 'Plan' tab for now / 24-06-14 */}
          <Tab>
            <SettingsDetails
              organization={organization}
              errors={errors}
              focus={focus}
            />
          </Tab>
          <Tab>
            <SettingsBilling organization={organization} errors={errors} />
          </Tab>
          <Tab>
            <SettingsPlans organization={organization} />
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}

General.layout = (page) => (
  <AppLayout title="Company settings">
    <OrganizationLayout
      header="Company settings"
      icon={
        <LayoutIcon>
          <CogwheelIcon size={40} className="text-black" />
        </LayoutIcon>
      }
    >
      {page}
    </OrganizationLayout>
  </AppLayout>
);
